import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaStar, FaRegStar } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { useLocation, useNavigate, useParams } from "react-router-dom";

export function LoginModal({ setShowModal }) {
  const [loading, setLoading] = useState(false);
  const {setTostMessage} = useContext(TostMessageContext);
  const [postData, setPostData] = useState({});
  const [cookies, setCookie] = useCookies();
  const navigate = useNavigate();
  const [stage, setStage] = useState('login');

    async function signIn() {
        const formData = new FormData();
        Object.entries(postData).forEach(([key, value]) => {
            formData.append(key, value);
        });

        setLoading(true)
        try {
            const response = await axios.post(base_url + '/login.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            setLoading(false)
            if (response.data.status) {
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
                const billing = {
                    full_name: response.data.user.full_name,
                    email: response.data.user.email,
                    phone: response.data.user.phone_number
                }
                if (response.data.user.email != null && response.data.user.email != undefined) {
                    setCookie("billingInfo", billing, {
                        path: "/",
                        maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
                        secure: true,
                        sameSite: "strict"
                    });
                }
                setShowModal(false);
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
        } catch (error) {
            setLoading(false)
            setTostMessage({
                messageType: 'error',
                message: "Network Error"
            })
        }
    }

    async function signUp() {
        const formData = new FormData();
        Object.entries(postData).forEach(([key, value]) => {
            formData.append(key, value);
        });

        setLoading(true)
        try {
            const response = await axios.post(base_url + '/signup.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            setLoading(false)
            if (response.data.status) {
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
                const billing = {
                    full_name: response.data.user.full_name,
                    email: response.data.user.email,
                    phone: response.data.user.phone_number
                }
                if (response.data.user.email != null && response.data.user.email != undefined) {
                    setCookie("billingInfo", billing, {
                        path: "/",
                        maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
                        secure: true,
                        sameSite: "strict"
                    });
                }
                setShowModal(false);
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
        } catch (error) {
            setLoading(false)
            setTostMessage({
                messageType: 'error',
                message: "Network Error"
            })
        }
    }

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div onClick={() => setShowModal(false)} className='w-[80%] flex justify-end text-underline text-[#ff0000] cursor-pointer'>Cancel</div>
                    {stage == "login" &&
                    <>
                        <a className='text-dark text-[20px] font-bold'>Sign-In</a>
                        <div className='w-[80%] bg-[#00b47a]/20 my-2 border-1 border-[#00b47a] rounded-md mx-auto py-3 flex items-center justify-center '>
                            <p className='text-sm text-center'>Rack up points when you shop from one account</p>
                        </div>
                        <div className="w-[85%] mx-auto mb-3">
                            <label className="text-sm text-gray-500">
                            {'Email'}
                            </label>
                            <input
                            className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                            value={postData?.email}
                            placeholder='Enter email...'
                            onChange={(e) => setPostData({...postData, email: e.target.value})}
                            />
                        </div>
                        <div className="w-[85%] mx-auto mb-3">
                            <label className="text-sm text-gray-500">
                            {'Password'}
                            </label>
                            <input
                            className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                            value={postData?.password}
                            placeholder='Enter password...'
                            onChange={(e) => setPostData({...postData, password: e.target.value})}
                            />
                        </div>
                        {/* Buttons */}
                        <div className="flex justify-between mt-5">
                            <button
                                onClick={() => signIn()}
                                className="
                                bg-[#7d5af6] text-white rounded-full font-semibold
                                px-8 py-3 transition hover:opacity-[0.8]
                                w-full md:w-auto md:self-center
                                "
                            >
                                Sign-In Now
                            </button>
                        </div>
                        <p onClick={() => setStage('signup')} className='text-[#7d5af6] text-sm underline my-2'>New here? Create an account</p>
                    </>
                    }
                    {stage == "signup" &&
                    <>
                        <a className='text-dark text-[20px] font-bold'>Create an Account</a>
                        <div className='w-[80%] bg-[#00b47a]/20 my-2 border-1 border-[#00b47a] rounded-md mx-auto py-3 flex items-center justify-center '>
                            <p className='text-sm text-center'>Rack up points when you shop from one account</p>
                        </div>
                        <div className="w-[85%] mx-auto mb-3">
                            <label className="text-sm text-gray-500">
                            {'Full Name'}
                            </label>
                            <input
                            className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                            value={postData?.full_name}
                            placeholder='Enter full name...'
                            onChange={(e) => setPostData({...postData, full_name: e.target.value})}
                            />
                        </div>
                        <div className="w-[85%] mx-auto mb-3">
                            <label className="text-sm text-gray-500">
                            {'Email'}
                            </label>
                            <input
                            className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                            value={postData?.email}
                            placeholder='Enter email...'
                            onChange={(e) => setPostData({...postData, email: e.target.value})}
                            />
                        </div>
                        <div className="w-[85%] mx-auto mb-3">
                            <label className="text-sm text-gray-500">
                            {'Phone Number'}
                            </label>
                            <input
                            className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                            value={postData?.phone_number}
                            placeholder='Enter phone number (+44 XXX)...'
                            onChange={(e) => setPostData({...postData, phone_number: e.target.value})}
                            />
                        </div>
                        <div className="w-[85%] mx-auto mb-3">
                            <label className="text-sm text-gray-500">
                            {'Password'}
                            </label>
                            <input
                            className="w-full bg-gray-100 rounded px-4 py-3 mt-1"
                            value={postData?.password}
                            placeholder='Enter password...'
                            onChange={(e) => setPostData({...postData, password: e.target.value})}
                            />
                        </div>
                        {/* Buttons */}
                        <div className="flex justify-between mt-5">
                            <button
                                onClick={() => signUp()}
                                className="
                                bg-[#7d5af6] text-white rounded-full font-semibold
                                px-8 py-3 transition hover:opacity-[0.8]
                                w-full md:w-auto md:self-center
                                "
                            >
                                Sign-Up Now
                            </button>
                        </div>
                        <p onClick={() => setStage('login')} className='text-[#7d5af6] text-sm underline my-2'>Already have an account? Sign-In</p>
                    </>
                    }
                {loading ? (
                    <ClockLoader
                        color={'#212121'}
                        loading={loading}
                        size={25}
                        className='mt-3'
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    ) : null
                }
            </div>  
        </div>
    )
}

